import React from 'react';
import PropTypes from 'prop-types';

import LargeScreen from 'common/large-screen';
import SmallScreen from 'common/small-screen';
import Button from 'common/button';
import Icon from 'common/icon';
import Link from 'common/link';
import cx from 'classnames';

const defaultClasses = 'text-gray-light hover:text-green';
const activeClasses = 'text-gray-base hover:text-gray-base';

const ContributeHeader = ({ activeStep, backUrl, onToggleZendesk, type, urls }) => (
    <div className="flex justify-between pb-8 border-b border-gray-lighter">
        <LargeScreen>
            <div className="bg-white rounded border-2 border-gray-lighter py-2 px-6 flex items-center">
                <Link to={urls.base} className={defaultClasses}>
                    <Icon icon="arrow-alt-left" />
                </Link>
                <Icon
                    icon="chevron-right"
                    type="solid"
                    size="sm"
                    className="text-gray-lighter mx-4"
                />
                <Link
                    to={urls.type}
                    className={cx('text-12 uppercase font-bold tracking-wide', {
                        [defaultClasses]: activeStep !== 'type',
                        [activeClasses]: activeStep === 'type',
                    })}
                >
                    Select Type
                </Link>
                <Icon
                    icon="chevron-right"
                    type="solid"
                    size="sm"
                    className="text-gray-lighter mx-4"
                />
                <Link
                    to={type === 'pledge' ? urls.pledgeAmount : urls.donateAmount}
                    className={cx('text-12 uppercase font-bold tracking-wide', {
                        [defaultClasses]: activeStep !== 'amount',
                        [activeClasses]: activeStep === 'amount',
                        'pointer-events-none': activeStep === 'type',
                    })}
                >
                    Select Amount
                </Link>
                <Icon
                    icon="chevron-right"
                    type="solid"
                    size="sm"
                    className="text-gray-lighter mx-4"
                />
                <Link
                    to={urls.payment}
                    className={cx('text-12 uppercase font-bold tracking-wide', {
                        [defaultClasses]: activeStep !== 'payment',
                        [activeClasses]: activeStep === 'payment',
                        'pointer-events-none': activeStep === 'type' || activeStep === 'amount',
                    })}
                >
                    Payment Details
                </Link>
                <Icon
                    icon="chevron-right"
                    type="solid"
                    size="sm"
                    className="text-gray-lighter mx-4"
                />
                <Link
                    to={urls.confirm}
                    className={cx('text-12 uppercase font-bold tracking-wide', {
                        [`${defaultClasses} pointer-events-none`]: activeStep !== 'confirm',
                        [activeClasses]: activeStep === 'confirm',
                    })}
                >
                    Confirm
                </Link>
            </div>
            <Button
                color="green"
                size="sm"
                className="text-12 uppercase font-bold tracking-wide px-8"
                onClick={onToggleZendesk}
                outline
            >
                Need Help?
            </Button>
        </LargeScreen>
        <SmallScreen>
            <Link to={backUrl} className="text-14 font-medium link-gray">
                <Icon icon="chevron-left" type="solid" className="mr-2" />
                Go back
            </Link>
            <button
                type="button"
                className="text-14 font-medium link-green"
                onClick={onToggleZendesk}
            >
                Need Help?
            </button>
        </SmallScreen>
    </div>
);

ContributeHeader.propTypes = {
    activeStep: PropTypes.oneOf(['type', 'amount', 'payment', 'confirm']).isRequired,
    backUrl: PropTypes.string.isRequired,
    onToggleZendesk: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['pledge', 'donate']),
    urls: PropTypes.shape({
        base: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        pledgeAmount: PropTypes.string.isRequired,
        donateAmount: PropTypes.string.isRequired,
        payment: PropTypes.string.isRequired,
        confirm: PropTypes.string.isRequired,
    }).isRequired,
};

ContributeHeader.defaultProps = {
    type: null,
};

export default ContributeHeader;
